import React, { useState, useEffect } from 'react';

const ImageLoader = ({ src, ...props }) => {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        setLoaded(false);
        const img = new Image();
        img.src = src;
        img.onload = () => {
            setLoaded(true);
        };
    }, [src]);

    return (
        <>
            {!loaded && <img src="./assets/ui/No_Image_Available.jpg" {...props} />}
            {loaded && <img src={src} {...props}  />}
        </>
    );
};

export default ImageLoader;
